export const VisitPriority = {
    NORMAL: 'normal',
    HIGH: 'high'
};
export const VisitsMode = {
    FORM: 'form',
    IMMEDIATE: 'immediate'
};
/** `update_all` values accepted by `InspectionVisitsController#create`. */
export const SeriesScope = {
    THIS_ONLY: 'false',
    BY_FREQUENCY: 'by_frequency',
    ALL: 'true'
};
